import apiClient from "@/lib/axios";

export const getTickets = async (params: GetTicketsParams): Promise<GetTicketsResponse> => {
  const response = await apiClient.get("/tickets", { params });
  return response.data;
};

export const getTicketById = async (params: GetTicketByIdParams): Promise<GetTicketByIdResponse> => {
  const response = await apiClient.get(`/tickets/${params.ticket_id}`);
  return response.data;
};

export const createTicket = async (params: CreateTicketDTO): Promise<CreateTicketResponse> => {
  const response = await apiClient.post("/tickets", params);
  return response.data;
}

export const updateTicket = async (params: UpdateTicketDTO, externalId: string): Promise<UpdateTicketResponse> => {
  const response = await apiClient.patch(`/tickets/${externalId}`, params);
  return response.data;
}

export const deleteTicket = async (externalId: string): Promise<void> => {
  const response = await apiClient.delete(`/tickets/${externalId}`);
  return response.data;
}

export const uploadEvidence = async (params: UploadEvidenceRequest): Promise<UploadEvidenceResponse> => {
  const formData = new FormData();
  formData.append('file', params.file);
  formData.append('organization_id', params.organization_id);
  
  const response = await apiClient.post(`/tickets/${params.ticket_id}/evidence`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}

export const markTicketRead = async (params: MarkTicketReadRequest): Promise<MarkTicketReadResponse> => {
  const response = await apiClient.patch(`/tickets/${params.ticket_id}/mark-read`);
  return response.data;
}

export const getUnreadMessages = async (): Promise<UnreadMessagesResponse> => {
  const response = await apiClient.get("/tickets/unread-messages");
  return response.data;
}